import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center px-4">
      <h1 className="text-foreground text-6xl">404</h1>
      <p className="text-muted-foreground mt-4 text-lg">Page not found</p>
      <p className="text-muted-foreground mt-2 text-sm">
        Let&apos;s get you back to your project dashboard.
      </p>
      <Link
        to="/home"
        className="bg-primary text-primary-foreground mt-8 rounded-sm px-6 py-2 text-sm font-medium transition-colors hover:bg-[#0E0E98]"
      >
        Go home
      </Link>
    </div>
  );
}
